<template>
  <v-container style="color: white">
    <div class="main_view">
      <div
        class="img-circle mr-5"
        :style="{'background-image': 'url(' + `${getImage}` + ')'}"
      ></div>

      <div class="description">
        <h1>
          {{ user.full_name }}
        </h1>
        <p>
          {{ user.description_of_member }}
        </p>
      </div>
    </div>
    <v-divider></v-divider>
    <h1>Experience :</h1>
    <h5>4 years including 2 at Nekologic</h5>
    <h5 class="mt-4">xp:</h5>
    <div class="jauge"><div class="xp_jauge" :style="{width: 30 + '%'}" /></div>

    <h5 class="mt-4">jp:</h5>
    <div class="jauge"><div class="xp_jauge" :style="{width: 40 + '%'}" /></div>
    <v-divider></v-divider>
    <h1>Skills :</h1>
    <div class="skills">
      <div style="display: flex; vertical-align: middle; flex-wrap: wrap">
        <h5>Languages:</h5>
        <div style="display: flex" v-for="(lvl, j) in lvls" :key="j">
          <div
            class="color_legend ml-4 mr-2 mt-1"
            :style="'background-color:' + CodeColor(lvl.colorCode)"
          ></div>
          <span>{{ lvl.text }}</span>
        </div>
      </div>

      <v-chip
        :color="CodeColor(language.colorCode)"
        class="mr-2 mt-2"
        dark
        v-for="(language, i) in languages"
        :key="i + 10000"
      >
        {{ language.text }}
      </v-chip>
      <div style="height: 30px"></div>
      <h5>Programing languages:</h5>
      <v-chip
        class="mr-2 mt-2"
        dark
        v-for="(pro, i) in programing_lang"
        :key="i + 100000"
      >
        {{ pro }}
      </v-chip>
      <div style="height: 30px"></div>
      <h5>Technologies:</h5>
      <v-chip class="mr-2 mt-2" dark v-for="(tech, i) in technologies" :key="i">
        {{ tech }}
      </v-chip>
    </div>
    <v-divider></v-divider>
    <h1>Projects :</h1>
    <div class="grid-container">
      <div class="project" v-for="i in 5" :key="i">
        <h6>Project {{ i }}</h6>
      </div>
    </div>
    <v-divider></v-divider>
  </v-container>
</template>
<script>
import {mapGetters} from "vuex";

export default {
  name: "User",
  props: ["userId"],
  data() {
    return {
      user: null,
      lvls: [
        {text: "Native", colorCode: 1},
        {text: "Advanced", colorCode: 2},
        {text: "Fluent", colorCode: 3},
        {text: "Intermediate", colorCode: 4},
        {text: "Low intermediate", colorCode: 5},
        {text: "Beginner", colorCode: 6},
      ],
      languages: [
        {text: "French", colorCode: 1},
        {text: "Spanish", colorCode: 2},
        {text: "Japanese", colorCode: 6},
      ],
      programing_lang: ["C", "C#", "Java"],
      technologies: ["VueJs", "Unity"],
    };
  },
  computed: {
    ...mapGetters(["userProfileData", "getTeamList"]),
    getImage() {
      let img = this.user.avatar_url;
      if (this.user.avatar_url === "" || this.user.avatar_url === null) {
        img = require("@/assets/image/NekologicSquare.png");
      }
      return img;
    },
  },
  created() {
    var id = parseInt(this.userId);
    if (this.userId === undefined) {
      id = this.userProfileData.user_id;
    }
    console.log(id);
    this.user = this.getTeamList.find((element) => element.id === id);
  },
  methods: {
    CodeColor(code) {
      if (code === 1) return "#264653";
      if (code === 2) return "#2a9d8f";
      if (code === 3) return "#8AB17D";
      if (code === 4) return "#e9c46a";
      if (code === 5) return "#f4a261";
      if (code === 6) return "#e76f51";
    },
  },
};
</script>
<style scoped>
.main_view {
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
}
.img-circle {
  border-radius: 50%;
  background-repeat: no-repeat;
  background-position-x: center;
  background-size: cover;
  height: 200px;
  width: 200px;
}
.color_legend {
  height: 18px;
  min-width: 18px;
  border-radius: 50%;
}
.description {
  width: 70%;
}
.jauge {
  border-radius: 50px;
  width: 400px;
  height: 10px;
  background-color: #6b907d;
}
.xp_jauge {
  border-radius: 50px;
  background-color: #f2db06;
  height: 100%;
}
.skills {
  margin-left: 20px;
}

.grid-container {
  margin-top: 20px;
  display: grid;
  grid-template-columns: 1fr 1fr 1fr;
  gap: 10px 10px;
}
.project {
  color: white;
  padding: 10px;
  height: 100px;
  width: 100%;
  background-color: tomato;
  border-radius: 10px;
}
@media only screen and (max-width: 800px) {
  .description {
    margin-top: 20px;
    width: 100%;
  }
  .jauge {
    width: 80%;
  }
}
</style>
